import { useAuthRestApi } from '../common';
import { Observable } from 'rxjs';
import { IOrcidApi } from '@vivli/features/studies/infrastructure/interface';

export const useOrcidApi = (): IOrcidApi => {
    const { handlePost } = useAuthRestApi();
    const getOrcidAuthToken = (code: string, datasetId: string, orcidId: string): Observable<string> => {
        /* Code left here intentionally for case when we resolve the issue with CORS
      const authUrl = new URL(`${config.studyOrcidConfig.authUrl}`);
           const data = `client_id=${config.studyOrcidConfig.clientId}&client_secret=${config.studyOrcidConfig.clientSecret}&grant_type=authorization_code&code=${code}&scope=%2Factivities%2Fupdate`;
      //&redirect_uri=${redirect}
           const options : IRestRequestOptions = {
               bypassAuth: true,
               baseUrl: authUrl.origin,
               additionalHeaders:{'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json'}
           }
           return handlePost<IOrcidToken>(`/oauth/token`, data, options);
           */

        return handlePost(`orcid/orcidCreds/${datasetId}/${orcidId}/${code}`);
    };

    const sendOrcidInvites = (datasetId: string): Observable<boolean> => {
        return handlePost(`orcid/orcidInvites/${datasetId}`);
    };

    return {
        getOrcidAuthToken,
        sendOrcidInvites
    };
};
